import { useState } from "react";
import { Habit } from "../types";
import { Action } from "./useHabitState";

export const useHabitActions = (dispatch: React.Dispatch<Action>) => {
  const [addHabitDialogOpen, setAddHabitDialogOpen] = useState(false);
  const [editHabitDialogOpen, setEditHabitDialogOpen] = useState(false);
  const [currentHabit, setCurrentHabit] = useState<Habit | null>(null);
  const [progressModalOpen, setProgressModalOpen] = useState(false);
  const [progressHabit, setProgressHabit] = useState<Habit | null>(null);
  const [progressValue, setProgressValue] = useState<number | "">("");

  const handleAddHabit = () => {
    const newHabit: Habit = {
      id: Date.now(),
      name: "",
      score: 0,
      archived: false,
    };
    setCurrentHabit(newHabit);
    setAddHabitDialogOpen(true);
  };

  const handleEditHabit = (habit: Habit) => {
    setCurrentHabit(habit);
    setEditHabitDialogOpen(true);
  };

  const handleSaveHabit = () => {
    if (currentHabit?.name && currentHabit.score !== undefined) {
      if (editHabitDialogOpen) {
        dispatch({ type: "EDIT_HABIT", payload: currentHabit });
      } else {
        dispatch({ type: "ADD_HABIT", payload: currentHabit });
      }
      setAddHabitDialogOpen(false);
      setEditHabitDialogOpen(false);
    }
  };

  const handleRemoveHabit = (id: number) => {
    dispatch({ type: "REMOVE_HABIT", payload: id });
    setEditHabitDialogOpen(false);
  };

  const handleToggleHabit = (
    date: string,
    habitId: number,
    score: number,
    progress?: number,
  ) => {
    dispatch({
      type: "TOGGLE_HABIT",
      payload: { date, habitId, score, progress },
    });
  };

  const handleArchiveHabit = (id: number) => {
    dispatch({ type: "ARCHIVE_HABIT", payload: id });
    setEditHabitDialogOpen(false);
  };

  const handleSortOrderChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    dispatch({
      type: "SET_SORT_ORDER",
      payload: event.target.value as "alphabetical" | "score",
    });
  };

  return {
    addHabitDialogOpen,
    setAddHabitDialogOpen,
    editHabitDialogOpen,
    setEditHabitDialogOpen,
    currentHabit,
    setCurrentHabit,
    progressModalOpen,
    setProgressModalOpen,
    progressHabit,
    setProgressHabit,
    progressValue,
    setProgressValue,
    handleAddHabit,
    handleEditHabit,
    handleSaveHabit,
    handleRemoveHabit,
    handleToggleHabit,
    handleArchiveHabit,
    handleSortOrderChange,
  };
};
